import dayjs from 'dayjs';
import { Flexer } from '../../styles';

export function PaymentReporter(props: {
  paymentDate: string;
  reporter: string;
}) {
  return (
    <Flexer className='reportingHistoryDataColumnDataCell' size='lg' minWidth='140px' textAlign='left'>
      Reported on {dayjs(props.paymentDate).format('MM/DD/YY')} by {props.reporter}
    </Flexer>
  );
}